<template>
    <div class="talk-dialog">
        <div class="talk-info">
            <div class="talk-title"></div>
            <div class="talk-cont">
                <p class="tel">手机号</p>
                <p class="we-chat">15931215125(同步微信)</p>
                <p class="line"></p>
                <p class="tel">微信</p>
                <p class="we-code"></p>
            </div>
            <div class="close-dialog" @click="closeTalk">X</div>
        </div>
    </div>
</template>

<script>
export default {
    name:'TalkDialog',
    methods:{
        closeTalk(){
            this.$emit('closeTalk',false)
        }
    }
}
</script>

<style lang="scss" scoped>
    .line{
        height:2px;
        border-bottom:1px solid #ccc;
        margin-bottom:40px;
    }
    .talk-dialog{
        position:fixed;
        width:100%;
        height:100%;
        background:rgba(0,0,0,.5);
        z-index:999;
    }
    .talk-info{
        width:690px;
        height:690px;
        position:absolute;
        left:50%;
        top:50%;
        background:#fff;
        border-radius:14px;
        transform:translateX(-345px) translateY(-500px);
        .talk-title{
            height:133px;
            background:url('../assets/img/talktitle.png') no-repeat;
            background-size:100% 100%;
        }
        .talk-cont{
            padding:50px;
            text-align:center;
            .tel{
                font-size:28px;
                color:#535353;
                margin-bottom:28px;
                font-weight:bold;
            }
            .we-chat{
                font-size:24px;
                color:#999;
                margin-bottom:40px;
                letter-spacing:1px;
            }
            .we-code{
                display:inline-block;
                width:218px;
                height:218px;
                background:url('../assets/img/contactcode2.png') no-repeat;
                background-size:100% 100%;
            }
        }
        .close-dialog{
            font-size:28px;
            width:60px;
            color:#fff;
            border:1px solid #fff;
            border-radius:50%;
            text-align:center;
            padding:16px 0;
            position:absolute;
            left:50%;
            bottom:-90px;
            transform:translateX(-30px);
        }
    }
</style>